/**
 * Collection heading: read more/less, overflow check for line-clamp, aria-expanded.
 * @param {HTMLElement} root
 */
function updateOverflowState(root) {
  const desc = root.querySelector("[data-collection-heading-clamp]");
  const btn = root.querySelector("[data-collection-heading-toggle]");
  if (!desc || !btn) return;

  if (root.getAttribute("data-expanded") === "true") {
    btn.hidden = false;
    return;
  }

  desc.classList.add("wf-collection-heading__description--clamped");
  // Force reflow
  // eslint-disable-next-line no-unused-expressions
  desc.offsetHeight;
  const overflowed = desc.scrollHeight > desc.clientHeight + 1;
  if (overflowed) {
    btn.hidden = false;
  } else {
    desc.classList.remove("wf-collection-heading__description--clamped");
    btn.hidden = true;
  }
}

/**
 * @param {HTMLElement} root
 * @param {boolean} expanded
 */
function setExpanded(root, expanded) {
  const desc = root.querySelector("[data-collection-heading-clamp]");
  const btn = root.querySelector("[data-collection-heading-toggle]");
  if (!desc || !btn) return;

  root.setAttribute("data-expanded", expanded ? "true" : "false");
  if (expanded) {
    desc.classList.remove("wf-collection-heading__description--clamped");
  } else {
    desc.classList.add("wf-collection-heading__description--clamped");
  }
  btn.setAttribute("aria-expanded", expanded ? "true" : "false");
  btn.textContent = expanded
    ? root.getAttribute("data-label-less") || "Show less"
    : root.getAttribute("data-label-more") || "Read more...";
  if (!expanded) {
    requestAnimationFrame(() => updateOverflowState(root));
  }
}

/**
 * @param {HTMLElement} root
 */
function initOne(root) {
  const desc = root.querySelector("[data-collection-heading-clamp]");
  const btn = root.querySelector("[data-collection-heading-toggle]");
  if (!desc || !btn) return;

  if (!desc.classList.contains("wf-collection-heading__description--clamped")) {
    desc.classList.add("wf-collection-heading__description--clamped");
  }
  requestAnimationFrame(() => updateOverflowState(root));

  btn.addEventListener("click", () => {
    const next = root.getAttribute("data-expanded") !== "true";
    setExpanded(root, next);
  });

  let t = /** @type {ReturnType<typeof setTimeout> | null} */ (null);
  window.addEventListener("resize", () => {
    if (t) clearTimeout(t);
    t = setTimeout(() => {
      if (root.getAttribute("data-expanded") !== "true") {
        updateOverflowState(root);
      }
    }, 150);
  });
}

function init() {
  document.querySelectorAll("[data-collection-heading]").forEach((root) => {
    if (root instanceof HTMLElement) initOne(root);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
